import React, { Component } from 'react';
import * as api from '../api/api';
import { Grid, GridCell } from 'rmwc/Grid';
import { connect } from 'react-redux';
import { Card } from 'rmwc/Card';
import { Typography } from 'rmwc/Typography';
import {
  List,
  ListItem,
  ListItemText,
  ListItemSecondaryText,
  ListItemGraphic
} from 'rmwc/List';
import GoogleTagManager from '../util/GoogleTagManager'
import ReactPixel from 'react-facebook-pixel';
import { Link } from 'react-router-dom'

class WelcomePage extends Component{

  constructor(props) {
    super(props)
    this.state = {
      errorMsg: '',
      open: false,
      questionOpen: false,
      data:{
        'payments': []
      },
      
    };
    
  }

  componentDidMount() {
    // ReactPixel.init('1483416865308171')
    //   ReactPixel.track('Purchase', {
    //   value: 'Signup',
    // });
    
  }

  render() {
    
    let noRegistrationContent

      noRegistrationContent = ( <div>
        
         
          <Typography use="subtitle2">Thank You for registering on MyCENTA. Click on the links below to register for</Typography>
          <br/><br/>
          <ListItem>
          
            <ListItemGraphic>star</ListItemGraphic>
            <ListItemText><Link to="/portal/app/tq_registration/TPO/new/0">CENTA Teaching Professionals' Olympiad (TPO) 2020</Link><br /><Typography use="caption">India's national competition for teachers</Typography></ListItemText>
          </ListItem>
          <br/>
          <ListItem>
            <ListItemGraphic>star</ListItemGraphic>
            <ListItemText><Link to="/portal/app/tq_registration/TQ/new/0">CENTA Teaching Quotient (TQ)</Link><br/><Typography use="caption">Competency score for teacher recruitment</Typography></ListItemText>
          </ListItem>
          <br/>
          <ListItem>
            <ListItemGraphic>star</ListItemGraphic>
            <ListItemText><Link to="/portal/app/mc_registration">CENTA Micro-Credentials</Link><br /><Typography use="caption">Certifications of excellence in teaching - focused on specific sets of competencies</Typography></ListItemText>
          </ListItem>
          <br/>
          <ListItem>
            <ListItemGraphic>star</ListItemGraphic>
            <ListItemText><Link to="/portal/app/fc_registration">CENTA Certification</Link><br /><Typography use="caption">Certification of excellence in teaching - combining all Micro-Credentials</Typography></ListItemText>
          </ListItem>
          
        
        
      </div>
    )
    
   

    return (
      <div class="mdc-layout-grid">
        <Card style={{padding: '25px'}}>
        <div class="mdc-layout-grid__inner"> 
          <div class="mdc-layout-grid__cell--span-10">
            <Typography use="headline5">Welcome To MyCENTA</Typography>
            <div></div>
            <div>
              <br/>
              {noRegistrationContent}  
            </div>
          <div class="mdc-layout-grid__cell--span-1"></div>
          <div class="mdc-layout-grid__cell--span-1"></div>
        </div>
      </div>
      </Card>
    </div>
    )
  }
}

function mapStateToProps({user, admin}) {
  return {
    user,
    admin
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(WelcomePage);



// WEBPACK FOOTER //
// ./src/views/WelcomePage.jsx